// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/error.proto (package no.jotta.openapi, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { proto3 } from "@bufbuild/protobuf";
/**
 * @generated from enum no.jotta.openapi.ErrorType
 */
export var ErrorType;
(function (ErrorType) {
    /**
     * Unknown error.  An example of where this error may be returned is
     * if a Status value received from another address space belongs to
     * an error-space that is not known in this address space.  Also
     * errors raised by APIs that do not return enough error information
     * may be converted to this error.
     *
     * @generated from enum value: UNKNOWN = 0;
     */
    ErrorType[ErrorType["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * deprecated
     *
     * @generated from enum value: UNKNOWN_ERROR = 11;
     */
    ErrorType[ErrorType["UNKNOWN_ERROR"] = 11] = "UNKNOWN_ERROR";
    /**
     * The operation completed successfully.
     *
     * @generated from enum value: OK = 9;
     */
    ErrorType[ErrorType["OK"] = 9] = "OK";
    /**
     * The operation was cancelled (typically by the caller).
     *
     * @generated from enum value: CANCELLED = 10;
     */
    ErrorType[ErrorType["CANCELLED"] = 10] = "CANCELLED";
    /**
     * Client specified an invalid argument.  Note that this differs
     * from FAILED_PRECONDITION.  INVALID_ARGUMENT indicates arguments
     * that are problematic regardless of the state of the system
     * (e.g., a malformed file name).
     *
     * @generated from enum value: INVALID_ARGUMENT = 12;
     */
    ErrorType[ErrorType["INVALID_ARGUMENT"] = 12] = "INVALID_ARGUMENT";
    /**
     * Deadline expired before operation could complete.  For operations
     * that change the state of the system, this error may be returned
     * even if the operation has completed successfully.  For example, a
     * successful response from a server could have been delayed long
     * enough for the deadline to expire.
     *
     * @generated from enum value: DEADLINE_EXCEEDED = 13;
     */
    ErrorType[ErrorType["DEADLINE_EXCEEDED"] = 13] = "DEADLINE_EXCEEDED";
    /**
     * Some requested entity (e.g., file or directory) was not found.
     *
     * @generated from enum value: NOT_FOUND = 14;
     */
    ErrorType[ErrorType["NOT_FOUND"] = 14] = "NOT_FOUND";
    /**
     * The caller does not have permission to execute the specified
     * operation.  PERMISSION_DENIED must not be used for rejections
     * caused by exhausting some resource (use RESOURCE_EXHAUSTED
     * instead for those errors).  PERMISSION_DENIED must not be
     * used if the caller cannot be identified (use UNAUTHENTICATED
     * instead for those errors).
     *
     * @generated from enum value: PERMISSION_DENIED = 16;
     */
    ErrorType[ErrorType["PERMISSION_DENIED"] = 16] = "PERMISSION_DENIED";
    /**
     * Deprecated
     *
     * @generated from enum value: UNAUTHORIZED = 4;
     */
    ErrorType[ErrorType["UNAUTHORIZED"] = 4] = "UNAUTHORIZED";
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or
     * perhaps the entire file system is out of space.
     *
     * @generated from enum value: RESOURCE_EXHAUSTED = 17;
     */
    ErrorType[ErrorType["RESOURCE_EXHAUSTED"] = 17] = "RESOURCE_EXHAUSTED";
    /**
     * Operation was rejected because the system is not in a state
     * required for the operation's execution.  For example, directory
     * to be deleted may be non-empty, an rmdir operation is applied to
     * a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     * (a) Use UNAVAILABLE if the client can retry just the failing call.
     * (b) Use ABORTED if the client should retry at a higher-level
     * (e.g., restarting a read-modify-write sequence).
     * (c) Use FAILED_PRECONDITION if the client should not retry until
     * the system state has been explicitly fixed.  E.g., if an "rmdir"
     * fails because the directory is non-empty, FAILED_PRECONDITION
     * should be returned since the client should not retry unless
     * they have first fixed up the directory by deleting files from it.
     *
     * @generated from enum value: FAILED_PRECONDITION = 18;
     */
    ErrorType[ErrorType["FAILED_PRECONDITION"] = 18] = "FAILED_PRECONDITION";
    /**
     * The operation was aborted, typically due to a concurrency issue
     * like sequencer check failures, transaction aborts, etc.
     *
     * @generated from enum value: ABORTED = 19;
     */
    ErrorType[ErrorType["ABORTED"] = 19] = "ABORTED";
    /**
     * Operation was attempted past the valid range.  E.g., seeking or
     * reading past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may
     * be fixed if the system state changes. For example, a 32-bit file
     * system will generate INVALID_ARGUMENT if asked to read at an
     * offset that is not in the range [0,2^32-1], but it will generate
     * OUT_OF_RANGE if asked to read from an offset past the current
     * file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and OUT_OF_RANGE.
     * We recommend using OUT_OF_RANGE (the more specific error) when it applies
     * so that callers who are iterating through
     * a space can easily look for an OUT_OF_RANGE error to detect when they are done.
     *
     * @generated from enum value: OUT_OF_RANGE = 20;
     */
    ErrorType[ErrorType["OUT_OF_RANGE"] = 20] = "OUT_OF_RANGE";
    /**
     * Operation is not implemented or not supported/enabled in this service.
     *
     * @generated from enum value: UNIMPLEMENTED = 21;
     */
    ErrorType[ErrorType["UNIMPLEMENTED"] = 21] = "UNIMPLEMENTED";
    /**
     * Internal errors.  Means some invariants expected by underlying
     * system has been broken.  If you see one of these errors,
     * something is very broken.
     *
     * @generated from enum value: INTERNAL = 22;
     */
    ErrorType[ErrorType["INTERNAL"] = 22] = "INTERNAL";
    /**
     * The service is currently unavailable.  This is a most likely a
     * transient condition and may be corrected by retrying with
     * a backoff. Note that it is not always safe to retry
     * non-idempotent operations.
     *
     * @generated from enum value: UNAVAILABLE = 23;
     */
    ErrorType[ErrorType["UNAVAILABLE"] = 23] = "UNAVAILABLE";
    /**
     * Unrecoverable data loss or corruption.
     *
     * @generated from enum value: DATA_LOSS = 24;
     */
    ErrorType[ErrorType["DATA_LOSS"] = 24] = "DATA_LOSS";
    /**
     * The request does not have valid authentication credentials for the operation, e.g access token was invalid.
     *
     * @generated from enum value: UNAUTHENTICATED = 3;
     */
    ErrorType[ErrorType["UNAUTHENTICATED"] = 3] = "UNAUTHENTICATED";
    /**
     * Some entity that we attempted to create (e.g., file or directory) already exists.
     *
     * @generated from enum value: ALREADY_EXISTS = 5;
     */
    ErrorType[ErrorType["ALREADY_EXISTS"] = 5] = "ALREADY_EXISTS";
    /**
     * @generated from enum value: FILE_NOT_FOUND = 1;
     */
    ErrorType[ErrorType["FILE_NOT_FOUND"] = 1] = "FILE_NOT_FOUND";
    /**
     * @generated from enum value: PATH_NOT_FOUND = 2;
     */
    ErrorType[ErrorType["PATH_NOT_FOUND"] = 2] = "PATH_NOT_FOUND";
    /**
     * There is a conflict on the given path for this operation.
     *
     * @generated from enum value: CONFLICT = 6;
     */
    ErrorType[ErrorType["CONFLICT"] = 6] = "CONFLICT";
    /**
     * @generated from enum value: PRECONDITIONS_FAILED = 7;
     */
    ErrorType[ErrorType["PRECONDITIONS_FAILED"] = 7] = "PRECONDITIONS_FAILED";
    /**
     * @generated from enum value: ACCOUNT_LOCKED = 8;
     */
    ErrorType[ErrorType["ACCOUNT_LOCKED"] = 8] = "ACCOUNT_LOCKED";
    /**
     * @generated from enum value: INVALID_EMAIL = 25;
     */
    ErrorType[ErrorType["INVALID_EMAIL"] = 25] = "INVALID_EMAIL";
    /**
     * @generated from enum value: EMAIL_IN_USE = 26;
     */
    ErrorType[ErrorType["EMAIL_IN_USE"] = 26] = "EMAIL_IN_USE";
    /**
     * @generated from enum value: INVALID_PHONE_NUMBER = 27;
     */
    ErrorType[ErrorType["INVALID_PHONE_NUMBER"] = 27] = "INVALID_PHONE_NUMBER";
    /**
     * @generated from enum value: PHONE_NUMBER_IN_USE = 28;
     */
    ErrorType[ErrorType["PHONE_NUMBER_IN_USE"] = 28] = "PHONE_NUMBER_IN_USE";
    /**
     * quota error types
     *
     * @generated from enum value: FS_NOT_PREPARED = 29;
     */
    ErrorType[ErrorType["FS_NOT_PREPARED"] = 29] = "FS_NOT_PREPARED";
    /**
     * @generated from enum value: FS_ALREADY_PREPARED = 30;
     */
    ErrorType[ErrorType["FS_ALREADY_PREPARED"] = 30] = "FS_ALREADY_PREPARED";
    /**
     * @generated from enum value: INSUFFICIENT_CAPACITY = 31;
     */
    ErrorType[ErrorType["INSUFFICIENT_CAPACITY"] = 31] = "INSUFFICIENT_CAPACITY";
    /**
     * @generated from enum value: READ_LOCKED = 32;
     */
    ErrorType[ErrorType["READ_LOCKED"] = 32] = "READ_LOCKED";
    /**
     * @generated from enum value: WRITE_LOCKED = 33;
     */
    ErrorType[ErrorType["WRITE_LOCKED"] = 33] = "WRITE_LOCKED";
    /**
     * @generated from enum value: TOO_MANY_DEVICES = 34;
     */
    ErrorType[ErrorType["TOO_MANY_DEVICES"] = 34] = "TOO_MANY_DEVICES";
    /**
     * @generated from enum value: TOO_MANY_USERS = 35;
     */
    ErrorType[ErrorType["TOO_MANY_USERS"] = 35] = "TOO_MANY_USERS";
    /**
     * @generated from enum value: QUOTA_FULL_WRITE_LOCKED = 36;
     */
    ErrorType[ErrorType["QUOTA_FULL_WRITE_LOCKED"] = 36] = "QUOTA_FULL_WRITE_LOCKED";
    /**
     * @generated from enum value: BREACH_WRITE_LOCKED = 37;
     */
    ErrorType[ErrorType["BREACH_WRITE_LOCKED"] = 37] = "BREACH_WRITE_LOCKED";
    /**
     * @generated from enum value: EXPIRED_READ_LOCKED = 38;
     */
    ErrorType[ErrorType["EXPIRED_READ_LOCKED"] = 38] = "EXPIRED_READ_LOCKED";
    /**
     * @generated from enum value: EXPIRED_WRITE_LOCKED = 39;
     */
    ErrorType[ErrorType["EXPIRED_WRITE_LOCKED"] = 39] = "EXPIRED_WRITE_LOCKED";
    /**
     * @generated from enum value: NEW_QUOTA_IS_LESS_THEN_USED_USER_CAPACITY = 40;
     */
    ErrorType[ErrorType["NEW_QUOTA_IS_LESS_THEN_USED_USER_CAPACITY"] = 40] = "NEW_QUOTA_IS_LESS_THEN_USED_USER_CAPACITY";
    /**
     * @generated from enum value: NEW_QUOTA_IS_GREATER_THEN_BIZ_ACCOUNT = 41;
     */
    ErrorType[ErrorType["NEW_QUOTA_IS_GREATER_THEN_BIZ_ACCOUNT"] = 41] = "NEW_QUOTA_IS_GREATER_THEN_BIZ_ACCOUNT";
    /**
     * @generated from enum value: NEW_QUOTA_IS_GRATER_THEN_BIZ_AVAILABLE = 42;
     */
    ErrorType[ErrorType["NEW_QUOTA_IS_GRATER_THEN_BIZ_AVAILABLE"] = 42] = "NEW_QUOTA_IS_GRATER_THEN_BIZ_AVAILABLE";
    /**
     * @generated from enum value: ASSET_EXPIRED = 43;
     */
    ErrorType[ErrorType["ASSET_EXPIRED"] = 43] = "ASSET_EXPIRED";
    /**
     * @generated from enum value: PAYMENT_FAILED = 44;
     */
    ErrorType[ErrorType["PAYMENT_FAILED"] = 44] = "PAYMENT_FAILED";
    /**
     * @generated from enum value: PAYMENT_DECLINED = 45;
     */
    ErrorType[ErrorType["PAYMENT_DECLINED"] = 45] = "PAYMENT_DECLINED";
    /**
     * conflict error types
     *
     * @generated from enum value: FILE_ONTO_FILE = 46;
     */
    ErrorType[ErrorType["FILE_ONTO_FILE"] = 46] = "FILE_ONTO_FILE";
    /**
     * @generated from enum value: FILE_ONTO_FOLDER = 47;
     */
    ErrorType[ErrorType["FILE_ONTO_FOLDER"] = 47] = "FILE_ONTO_FOLDER";
    /**
     * @generated from enum value: FOLDER_ONTO_FILE = 48;
     */
    ErrorType[ErrorType["FOLDER_ONTO_FILE"] = 48] = "FOLDER_ONTO_FILE";
    /**
     * @generated from enum value: ILLEGAL_CONTENT = 49;
     */
    ErrorType[ErrorType["ILLEGAL_CONTENT"] = 49] = "ILLEGAL_CONTENT";
    /**
     * @generated from enum value: EMAIL_UNVERIFIED = 50;
     */
    ErrorType[ErrorType["EMAIL_UNVERIFIED"] = 50] = "EMAIL_UNVERIFIED";
})(ErrorType || (ErrorType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ErrorType)
proto3.util.setEnumType(ErrorType, "no.jotta.openapi.ErrorType", [
    { no: 0, name: "UNKNOWN" },
    { no: 11, name: "UNKNOWN_ERROR" },
    { no: 9, name: "OK" },
    { no: 10, name: "CANCELLED" },
    { no: 12, name: "INVALID_ARGUMENT" },
    { no: 13, name: "DEADLINE_EXCEEDED" },
    { no: 14, name: "NOT_FOUND" },
    { no: 16, name: "PERMISSION_DENIED" },
    { no: 4, name: "UNAUTHORIZED" },
    { no: 17, name: "RESOURCE_EXHAUSTED" },
    { no: 18, name: "FAILED_PRECONDITION" },
    { no: 19, name: "ABORTED" },
    { no: 20, name: "OUT_OF_RANGE" },
    { no: 21, name: "UNIMPLEMENTED" },
    { no: 22, name: "INTERNAL" },
    { no: 23, name: "UNAVAILABLE" },
    { no: 24, name: "DATA_LOSS" },
    { no: 3, name: "UNAUTHENTICATED" },
    { no: 5, name: "ALREADY_EXISTS" },
    { no: 1, name: "FILE_NOT_FOUND" },
    { no: 2, name: "PATH_NOT_FOUND" },
    { no: 6, name: "CONFLICT" },
    { no: 7, name: "PRECONDITIONS_FAILED" },
    { no: 8, name: "ACCOUNT_LOCKED" },
    { no: 25, name: "INVALID_EMAIL" },
    { no: 26, name: "EMAIL_IN_USE" },
    { no: 27, name: "INVALID_PHONE_NUMBER" },
    { no: 28, name: "PHONE_NUMBER_IN_USE" },
    { no: 29, name: "FS_NOT_PREPARED" },
    { no: 30, name: "FS_ALREADY_PREPARED" },
    { no: 31, name: "INSUFFICIENT_CAPACITY" },
    { no: 32, name: "READ_LOCKED" },
    { no: 33, name: "WRITE_LOCKED" },
    { no: 34, name: "TOO_MANY_DEVICES" },
    { no: 35, name: "TOO_MANY_USERS" },
    { no: 36, name: "QUOTA_FULL_WRITE_LOCKED" },
    { no: 37, name: "BREACH_WRITE_LOCKED" },
    { no: 38, name: "EXPIRED_READ_LOCKED" },
    { no: 39, name: "EXPIRED_WRITE_LOCKED" },
    { no: 40, name: "NEW_QUOTA_IS_LESS_THEN_USED_USER_CAPACITY" },
    { no: 41, name: "NEW_QUOTA_IS_GREATER_THEN_BIZ_ACCOUNT" },
    { no: 42, name: "NEW_QUOTA_IS_GRATER_THEN_BIZ_AVAILABLE" },
    { no: 43, name: "ASSET_EXPIRED" },
    { no: 44, name: "PAYMENT_FAILED" },
    { no: 45, name: "PAYMENT_DECLINED" },
    { no: 46, name: "FILE_ONTO_FILE" },
    { no: 47, name: "FILE_ONTO_FOLDER" },
    { no: 48, name: "FOLDER_ONTO_FILE" },
    { no: 49, name: "ILLEGAL_CONTENT" },
    { no: 50, name: "EMAIL_UNVERIFIED" },
]);
